import React from "react";

const items = [
  { text: "EXQUISITE DISHES", highlight: false },
  { text: "EMBARK ON A GASTRONOMIC JOURNEY", highlight: true },
  { text: "AUTHENTIC ROYAL FLAVOURS", highlight: false },
  { text: "PERFECTED FOR ROYAL PALATES", highlight: true },
  { text: "DISCOVER CULINARY EXCELLENCE", highlight: false },
  { text: "SIGNATURE GRILL & BIRYANI", highlight: true },
];

const ScrollingTicker = () => {
  return (
    <div className="relative py-4 bg-[#0B1215] border-y border-[#D4AF37]/30 overflow-hidden select-none shadow-md">
      {/* Background Subtle Ambient Glow */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#D4AF37]/5 via-transparent to-[#D4AF37]/5 pointer-events-none" />

      {/* Marquee Track */}
      <div className="animate-marquee whitespace-nowrap items-center">
        {/* Render 4 sets for seamless continuous loop */}
        {[...items, ...items, ...items, ...items].map((item, idx) => (
          <div key={idx} className="flex items-center gap-8 px-6">
            <span
              className={`text-base sm:text-lg lg:text-xl font-bold tracking-[0.25em] uppercase transition-colors ${
                item.highlight
                  ? "text-[#F3E5AB] drop-shadow-[0_0_8px_rgba(243,229,171,0.2)]"
                  : "text-white"
              }`}
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              {item.text}
            </span>
            <span className="text-[#D4AF37] text-sm lg:text-base opacity-80 select-none">
              ⚜
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScrollingTicker;

